import cn from "classnames"

import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { EntityStatusIcon } from "@/icons"
import { ProcessingMeta } from "./components/ProcessingMeta"
import { ResolvedMeta } from "./components/ResolvedMeta"
import { StatusBar } from "./components/StatusBar"

import styles from "./IssueStatusAlert.module.scss"

import type { IssueStatusAlertProps } from "./IssueStatusAlert.types"

export const IssueStatusAlert = (props: IssueStatusAlertProps) => {
  const { t } = useTranslation()
  const { type } = props
  const { title = t(`issue.${type}.title`), Icon = EntityStatusIcon } = props

  if (type === "open") return null

  return (
    <Flex
      gap={12}
      align="flex-start"
      className={cn(styles.container, {
        "resolved-tag-theme-ks": type === "resolved",
        [styles.metaProcessingTheme]: type === "processing"
      })}
    >
      <Icon type={type} className={styles.icon} />
      <Flex vertical className={styles.content}>
        <span className={styles.title}>{title}</span>
        {props.children}
      </Flex>
    </Flex>
  )
}

IssueStatusAlert.Resolved = {
  titleKey: "resolved",
  Meta: ResolvedMeta
}

IssueStatusAlert.Processing = {
  titleKey: "processing",
  Meta: ProcessingMeta
}

IssueStatusAlert.StatusBar = StatusBar
